'use client';

import { useLocale } from 'next-intl';
import type { ComponentType, JSX } from 'react';
import { DonationFormConfigProvider } from '../../DonationFormConfigContext';
import useDonationForm from '../../helpers/useDonationForm';
import UpdateCodonationOnDonationChange from './UpdateCodonationOnDonationChange';
import { withCaptchaProvider } from '@/components/Captcha';
import { MessagesProvider } from '@/components/Messages';
import type { DonationFormConfig, DonationFormProps } from '@/donationForm/types';
import { withStripeProvider } from '@/donationPages/_dependencies/StripeContext';
import { ActionFormProvider } from '@/form/ActionForm';
function withConfigProvider<P extends {
  config: DonationFormConfig;
}>(FormComponent: ComponentType<P>) {
  return function WithConfigProvider(props: P) {
    const {
      config
    } = props;
    return <DonationFormConfigProvider config={config}>
        <FormComponent {...props} />
      </DonationFormConfigProvider>;
  };
}
function withFormProviders(FormComponent: ComponentType<DonationFormProps>) {
  return withCaptchaProvider(withConfigProvider(withStripeProvider(function Form({
    config,
    initialFFs,
    initialFormValues,
    bootstrapData,
    loggingData,
    children
  }: DonationFormProps & JSX.IntrinsicAttributes) {
    const {
      action,
      onSubmit,
      id,
      ...providerProps
    } = useDonationForm(initialFormValues);
    const locale = useLocale();
    return <MessagesProvider locale={locale}>
            <ActionFormProvider {...providerProps}>
              <UpdateCodonationOnDonationChange />
              <FormComponent config={config} action={action} onSubmit={onSubmit} id={id} initialFFs={initialFFs} initialFormValues={initialFormValues} bootstrapData={bootstrapData} loggingData={loggingData}>
                {children}
              </FormComponent>
            </ActionFormProvider>
          </MessagesProvider>;
  })));
}
export default withFormProviders;